// import React from "react";
// import { useState } from "react";
// import { useForm } from "react-hook-form";
// import { FaArrowCircleLeft } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { toast } from "react-toastify";
// import postData from "../../../hooks/postData";
// import { useTranslation } from "react-i18next";
// import LoadingSpinner from "../../../components/utils/LoadingSpinner";

// const AddCustomer = () => {
//   const { t } = useTranslation();
//   const { register, reset, handleSubmit } = useForm();
//   const [loading, setLoading] = useState(false);

//   const onSubmit = async (data) => {
//     setLoading(true);
//     const response = await postData("/vendor/createcustomer", data);
//     if (response) {
//       toast.success("Customer added Successfully");
//       reset();
//     } else {
//       toast.error("Something went Wrong");
//     }
//     setLoading(false);
//   };

//   if (loading) {
//     return <LoadingSpinner />;
//   }

//   return (
//     <>
//       <div className="flex">
//         <h2 className="text-title text-lg md:text-2xl pb-2 mr-3">
//           {t("add_customers")}
//         </h2>
//         <Link to={"/vendor/customers"}>
//           <button className="btn btn-primary btn-xs rounded text-white mb-5 flex justify-center items-center gap-x-2">
//             <FaArrowCircleLeft size={15} />
//             {t("add_new_product_back")}
//           </button>
//         </Link>
//       </div>
//       <div className="mt-4">
//         <div className="flex flex-col gap-4 md:px-12 bg-white border rounded shadow p-5">
//           <form onSubmit={handleSubmit(onSubmit)}>
//             <div className="form-control grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-5 ">
//               <div>
//                 <label className="label">
//                   <span className="label-text">{t("Full_Name")}</span>
//                 </label>
//                 <input
//                   {...register("cust_fullname")}
//                   type="text"
//                   placeholder={`${t("Full_Name")}`}
//                   className="input input-bordered input-sm w-full rounded-none"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="label">
//                   <span className="label-text">{t("l_phone")}</span>
//                 </label>
//                 <input
//                   {...register("cust_phone")}
//                   type="number"
//                   placeholder={`${t("num")}`}
//                   className="input input-bordered input-sm w-full rounded-none"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="label">
//                   <span className="label-text">{t("form_email")}</span>
//                 </label>
//                 <input
//                   {...register("cust_email")}
//                   type="email"
//                   placeholder="demo@gmail.com"
//                   className="input input-bordered input-sm w-full rounded-none"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="label">
//                   <span className="label-text">{t("l_p")}</span>
//                 </label>
//                 <input
//                   {...register("cust_password")}
//                   type="text"
//                   className="input input-bordered input-sm w-full rounded-none"
//                   required
//                 />
//               </div>
//             </div>
//             <button className="btn btn-sm btn-primary rounded text-white mt-5">
//               {t("add_customer")}
//             </button>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddCustomer;

import React, { useState } from "react";
import { Form, Input, Button, Row, Col, Card, Typography, message } from "antd";
import { FaArrowCircleLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import postData from "../../../hooks/postData";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";

const { Title } = Typography;

const AddCustomer = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    const response = await postData("/vendor/createcustomer", values);
    if (response?.status_code === 200) {
      message.success(t("Customer added Successfully"));
      form.resetFields();
    } else {
      message.error(t("Something went Wrong"));
    }
    setLoading(false);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <Title level={4}>{t("add_customers")}</Title>
        <Link to="/vendor/customers">
          <button className="btn btn-primary btn-sm w-full rounded-md text-white" >
            <FaArrowCircleLeft />  {t("add_new_product_back")}
          </button>
        </Link>
      </div>

      <Card bordered className="shadow-md">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ cust_password: "" }}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Full_Name")}
                name="cust_fullname"
                rules={[
                  {
                    required: true,
                    message: t("Full name is required"),
                  },
                  {
                    pattern: /^[a-zA-Z ,.'-]+$/i,
                    message: t("Name must only contain alphabet letters"),
                  },
                ]}
              >
                <Input placeholder={t("Full_Name")} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={t("l_phone")}
                name="cust_phone"
                rules={[
                  {
                    required: true,
                    message: t("Phone is required"),
                  },
                  {
                    max: 12,
                    message: t("Contact number can't exceed more than 12 digits"),
                  },
                ]}
              >
                <Input type="number" placeholder={t("num")} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={t("form_email")}
                name="cust_email"
                rules={[
                  {
                    required: true,
                    message: t("Email is required"),
                  },
                  {
                    type: "email",
                    message: t("Enter a valid email address"),
                  },
                ]}
              >
                <Input placeholder="demo@gmail.com" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label={t("l_p")}
                name="cust_password"
                rules={[
                  {
                    required: true,
                    message: t("Password is required"),
                  },
                ]}
              >
                <Input.Password placeholder={t("l_p")} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <button type="submit" className="btn btn-primary w-full rounded-md text-white">
              {t("add_customer")}
            </button>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default AddCustomer;
